module.exports = __webpack_public_path__ + "static/media/asset-raw.812fd021.png";